<div
    style="display: flex; gap: 10px; flex-direction: column;left: 6%;width: 90%; position: relative; margin-top: 15px;">
    <div
        style="color: #0E0E0E; font-size: 16px; font-family: Montserrat; font-weight: 600; letter-spacing: 0.04px; word-wrap: break-word">
        Banner hub</div>
    <div class="main-box">
        <div style="margin-bottom: 10px;" fxLayout="row" fxLayoutAlign="space-between center">
            <span style="font-size: 16px; font-family: Montserrat; font-weight: 700;">Scheduled banners</span>
            <button class="create-button"  routerLink="/admin/banner-hub/create-banner">
                <div class="text">
                    <img src="assets/blue-plus.svg">
                    Schedule New Banner
                </div>
            </button>
        </div>
        <hr style="margin: 0px;">
        <div fxLayout="row">
            <div class="banner-list-section" fxFlex="30">
                <button style="border-radius: 8px;border: 1px #ECECEC solid;background: #F4F6FA;width: 55%;">
                    <mat-select [(value)]="bannerFilterType" class="dropdown-text" style="padding: 10px;">
                        <mat-option style="color: #386AF6;" value="allBanner" class="dropdown-text" (click)="filterBannerByStatus('ALLBANNER')">All
                            Banners({{allBannerList.length}})</mat-option>
                        <mat-option value="activeBanner" class="dropdown-text" (click)="filterBannerByStatus('ACTIVE')">Active Banners</mat-option>
                        <mat-option value="queuedBanner" class="dropdown-text" (click)="filterBannerByStatus('QUEUED')">Queued Banners</mat-option>
                    </mat-select>
                </button>
                <div *ngFor="let banner of allBannerListForShow" class="list-item" fxLayout="row"
                    [ngStyle]="selectedBannerId===banner.banner_schedule_id && {'background': 'white'}"
                    (click)="selectedBanner(banner.banner_schedule_id)">
                    <div *ngIf="banner.type=='BOT'" fxFlex="70">{{banner.bot.name}}</div>
                    <div *ngIf="banner.type=='URL'" fxFlex="70" >{{banner.url.substring(0, 15)}}..</div>
                    <div *ngIf="banner.status==='ACTIVE'" fxFlex="30" class="status-chip">
                        <img src="assets/green-icon.svg">
                        <span class="status-text">Active</span>
                    </div>
                    <div *ngIf="banner.status==='QUEUED'" fxFlex="30" class="status-chip">
                        <img src="assets/orange-icon.svg">
                        <span class="status-text">Queued</span>
                    </div>
                </div>

            </div>
            <div fxFlex="70" style="padding: 20px; padding-left: 50px; padding-top: 50px;" *ngIf="allBannerListForShow.length>0">
                <div fxLayout="row" style="gap: 20px;">
                    <div fxFlex="55">
                        <img [src]="selectedBannerDetails.imageLink"
                            style="border-radius: 14.79px;width: 100%;height: 150px;">
                    </div>
                    <div fxFlex="45" fxLayout="column" style="justify-content: space-around;">
                        <div  *ngIf="selectedBannerDetails.type=='BOT'" fxLayout="column">
                            <span  class="preview-title">Linked to</span>
                            <span class="preview-value">{{selectedBannerDetails.botName}}</span>
                        </div>
                        <div *ngIf="selectedBannerDetails.type=='URL'" fxLayout="column">
                            <span  class="preview-title">URL</span>
                            <a class="preview-value" href="{{selectedBannerDetails.url}}" target="_blank"> {{selectedBannerDetails.url.substring(0,145)}}..</a>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <div fxLayout="column">
                                <span class="preview-title">Active from</span>
                                <span class="preview-value">{{selectedBannerDetails.startTime | dateTransform: 'timestamp'}}</span>
                            </div>
                            <div fxLayout="column">
                                <span class="preview-title">Active to</span>
                                <span class="preview-value">{{selectedBannerDetails.endTime | dateTransform: 'timestamp'}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="button">
                    <button class="deactivate-button" (click)="deactivateBanner(selectedBannerDetails)">Deactivate</button>
                    <button class="reschedule-button" (click)="rescheduleBanner(selectedBannerDetails)">Reschedule</button>
                </div>
            </div>
        </div>
    </div>
    <div class="main-box">
        <div style="margin-bottom: 10px;" fxLayout="row" fxLayoutAlign="space-between center">
            <span style="font-size: 16px; font-family: Montserrat; font-weight: 700;">Banner Library</span>
            <button class="create-button">
                <div class="text">
                    <img src="assets/blue-plus.svg">
                    Upload New Banner
                </div>
            </button>
        </div>
    </div>
</div>